export default __webpack_public_path__ + "static/media/mad_sys_builder.d04ec03e.png";